import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { fundCallsApi } from 'src/Services/API';

/**
 * Les appels de fonds ne bougent qu'à l'envoi ou à l'enregistrement d'un versement, deux
 * gestes qui invalident déjà le cache. Sans ce délai, chaque retour sur l'onglet relançait la
 * requête et réaffichait le loader.
 */
const STALE_TIME = 60_000;

/** Tous les appels de fonds du bien. Un membre n'y voit que ceux où il a une ligne. */
export const useFundCalls = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fund-calls', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await fundCallsApi.fundCallsControllerFindAll(assetId)).data;
    },
    enabled: !!assetId,
    staleTime: STALE_TIME,
  });
};

export const useFundCall = (id?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fund-calls', assetId, id],
    queryFn: async () => {
      if (!assetId || !id) throw new Error('No assetId or id provided');
      return (await fundCallsApi.fundCallsControllerFindOne(assetId, id)).data;
    },
    enabled: !!assetId && !!id,
  });
};

/** Mes lignes encore à verser : sert le bandeau et « Mon relevé ». */
export const useMyFundCallLines = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fund-calls', assetId, 'mine'],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await fundCallsApi.fundCallsControllerFindMine(assetId)).data;
    },
    enabled: !!assetId,
    staleTime: STALE_TIME,
  });
};
